import _ from "lodash";
import { daysOfWeek, initialSlots } from "../../config";
import React, { useState, useEffect } from "react";
import { Container, Row, Col, Button, Modal } from "react-bootstrap";

const SlotTimePicker = ({ setSlots, slot }) => {
  const [allSlots, setAllSlots] = useState();
  const [selectedDay, setSelectedDay] = useState(null);

  const [selectedSlotsByDay, setSelectedSlotsByDay] = useState(slot);

  const [modalShow, setModalShow] = React.useState(false);

  useEffect(() => {
    setAllSlots({ ...initialSlots, ...slot });
  }, [slot]);

  const handleDaySelect = (day) => {
    setSelectedDay(day);

    if (!_.isEmpty(selectedSlotsByDay) && !selectedSlotsByDay.hasOwnProperty(day)) {
      setSelectedSlotsByDay((prevSelectedSlots) => ({
        ...prevSelectedSlots,
        [day]: allSlots[day],
      }));
    }
  };
  const handleSlotToggle = (slot) => {
    setSelectedSlotsByDay((prevSelectedSlots = {}) => ({
      ...prevSelectedSlots,
      [selectedDay]: {
        ...prevSelectedSlots?.[selectedDay],
        [slot]: !prevSelectedSlots?.[selectedDay]?.[slot],
      },
    }));
  };

  const timeSlots = Object.keys(initialSlots[0]);
  const handleSave = () => {
    setSlots({ ...initialSlots, ...selectedSlotsByDay });
    setModalShow(false);
  };
  return (
    <>
      <Button variant="primary" onClick={() => setModalShow(true)}>
        Select Slots
      </Button>
      <Modal
        show={modalShow}
        onHide={() => setModalShow(false)}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">Slots</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            {Object.keys(initialSlots).map((day) => (
              <Col key={day}>
                <Button
                  variant={selectedDay === day ? "success" : "light"}
                  onClick={() => handleDaySelect(day)}
                >
                  {daysOfWeek[day]}
                </Button>
              </Col>
            ))}
          </Row>
          {allSlots && selectedDay !== null && (
            <div>
              <h4>{daysOfWeek[selectedDay]}</h4>
              <div className="time-slot-grid">
                {!_.isEmpty(timeSlots) && timeSlots?.map((slot) => (
                  <Button
                    key={slot}
                    variant={
                      selectedSlotsByDay?.[selectedDay]?.[slot]
                        ? "success"
                        : "light"
                    }
                    onClick={() => handleSlotToggle(slot)}
                    style={{ width: "80px", marginBottom: "5px" }}
                  >
                    {slot}
                  </Button>
                ))}
              </div>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={handleSave}>Save</Button>
          <Button onClick={() => setModalShow(false)}>Close</Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default SlotTimePicker;
